export const GET = ({ url, before, success, error, after }) => {
  if (before) { before() }
  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      if (success) { success(data) }
    })
    .catch((errors) => {
      if (error) {
        error(errors)
      } else {
        console.error(errors)
      }
    })
    .finally(() => {
      if (after) { after() }
    });
}

export const POST = ({ url, data, before, success, error, after }) => {
  if (before) { before() }
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((response) => {
      if (response.ok) { return response.json() }
      throw new Error("Network response was not ok.")
    })
    .then((data) => {
      if (success) { success(data) }
    })
    .catch((errors) => {
      if (error) {
        error(errors)
      } else {
        console.error(errors)
      }
    })
    .finally(() => {
      if (after) { after() }
    });
}